import React, { ComponentProps } from 'react';
import { asFetchableBlock } from '../../_lib/BlockFetcher';
import { BlockType } from '../../types/api/ElementType';
import { DefaultView, Views } from '../../types/BlockWithViews';
import { PageStatisticsDefaultView } from './views/PageStatisticsDefaultView';

type PageStatisticsProps = Views<DefaultView<PageStatisticsDefaultView>>;

/**
 * Block to display PageStatistics inside a Tab Panel.
 */
function PageStatistics({ views }: PageStatisticsProps) {
  return <PageStatisticsDefaultView {...views.default} />;
}

export const PageStatisticsBlock = asFetchableBlock(PageStatistics, BlockType.pagestatistics);
export type PageStatisticsBlock = ComponentProps<typeof PageStatisticsBlock>;
